<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.DocumentType"
                   :create="openCreateModal">
        <h1 class="title">{{$t('entities.documentTypes')}}</h1>
      </page-header>

      <datatable :fetch="$api.fetchDocumentTypes"
                 ref="listDocumentTypes"
                 identifier="name">
        <div slot="name"
             slot-scope="{ item }"
             :title="$t('common.name')"
             :sortable="true">
          <span>{{ item.name }}</span>
        </div>
        <div slot="code"
             slot-scope="{ item }"
             :title="$t('common.code')"
             :sortable="true">
          <span>{{ item.code }}</span>
        </div>
        <div slot="actions"
             slot-scope="{ item }">
          <router-link :to="'/documenttype/' + item.id"
                       class="button is-primary">
            <i class="fa fa-search"></i>
          </router-link>
        </div>
      </datatable>
    </div>

    <modal ref="createDocumentTypeModal"
           @create="createDocumentType"
           :title="$t('documentTypes.documentTypeCreation')">
      <div class="columns">
        <div class="column is-half">
          <text-field :label="$t('common.name')"
                      v-model="documentType.name"
                      :inline="false"
                      :edit="true"
                      required></text-field>
          <text-field :label="$t('common.code')"
                      v-model="documentType.code"
                      :inline="false"
                      :edit="true" />
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'document-type-list',
  data () {
    return {
      documentType: {},
    };
  },
  methods: {
    openCreateModal () {
      this.$refs.createDocumentTypeModal.open();
    },
    createDocumentType () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          axios.post('/documenttype', this.documentType).then((response) => {
            if (response.data.success) {
              this.documentType = {};
              this.$refs.listDocumentTypes.refresh();
              this.$refs.createDocumentTypeModal.close();
              this.$router.push({
                name: 'DocumentType',
                params: { id: response.data.id },
              });
            }
          });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>

